/* eslint-disable max-classes-per-file */
import { LagermalDTO } from "~app/common/models/lagermal/LagermalResponseDTO";
import { LagermalYearRequestDTO } from "~app/common/models/lagermal/LagermalYearRequestDTO";

export class LagermalWorkItem extends LagermalDTO {
    standardVardeOnSave: boolean;
    invalid: boolean;
    parentId: number;
    uniqueId: number;
    expanded: boolean;
}

export enum LagermalView {
    // Dagar visar egenskapen 'lagermal' vilket är dagar

    Dagar = "lagermal",

    Kvantitet = "kvantitet"
}

export class LagermalRequest extends LagermalYearRequestDTO {
    monamn: string;
    ponamn: string;
}

export class Radtyp {
    static get produktgrupp(): string { return "PG"; }
    static get handelssortiment(): string { return "HS"; }
}
